exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-table {\n  width: 100%; }\n\nmat-paginator {\n  margin-top: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/SharedModule/LogsComponent/logs.component.scss
// module id = ../../../../../src/SharedModule/LogsComponent/logs.component.scss
// module chunks = main